export interface ItemInfo {
    id : number,
    name : string,
    avatar : string,
    info : string
};

export interface ItemInfoProp {
    item: ItemInfo;
    submit: any;
}

export const enum ContentType {
    TYPE_USER = 0,
    TYPE_CONTENT,
    TYPE_LIKE,
    TYPE_SUPERLIKE,
    TYPE_COMMENT,
    TYPE_COMMENT_LIKE,
    TYPE_COMMENT_DISLIKE,
    TYPE_FOLLOW,
    TYPE_FRIEND,
    TYPE_SHARE,
}

export interface ContentInfo {
    id : number,
    type : string,
    user : number,
    user_name : string,
    user_avatar : string,
    user_bm : number,
    thumbnail : string,
    title : string,
    desc : string,
    time : string,
    visibility : string,
    height: number,
    likes : number,
    comments : number,
    user_likes : number,
    locked : number,
    nsfw : number,
    views : number,
    images : string[],
    widths : number[],
    heights : number[],
    relationship : number,
    meta : number,
    supporters : string[],
    react_comments : string[],
    opening : boolean,
    action: string,
    action_lbl: string,
    reply_only : boolean,
    sponsored : boolean
};

export interface ContentDetail {
    id : number,
    title : string,
    desc : string,
    url : string,
    type : string
};

export interface ContentInterface {
    content: ContentInfo;
};

export interface ContentUpdateInt {
    content: ContentInfo;
    index : number;
    onUpdate : any;
    view : string;
    autoplay : boolean;
};

export interface CommentInfo {
    id : number;
    user : number,
    user_name : string,
    user_avatar : string,
    user_bm : number,
    comment : string,
    likes: number,
    like_done : number,
    dislikes: number,
    dislike_done : number,
    owned : number,
    image : string,
    date : string,
    owner_like : string,
    reply_id : number,
    reply_user: string,
    reply_comment: string,
    type : number
};

export interface CommentLikeDetail {
    id : number;
    user : number;
    name : string,
    avatar : string,
    like : number
};

export interface NotiInfo {
    id : number;
    avatar : string,
    icon : number,
    highlight : string,
    title : string,
    path : string,
    time : string,
    read : number
};

// build the content info
export const CreateContentInfo = (id : number, type : string, name : string, avatar : string) : ContentInfo => {
	let content : ContentInfo = {
        id : id,
        type : type,
        user : -1,
        user_name : name,
        user_avatar : avatar,
        user_bm : 0,
        thumbnail : "",
        title : "",
        desc : "",
        time : "",
        visibility : "",
        height: 0,
        likes : 0,
        comments : 0,
        user_likes: 0,
        locked: 0,
        nsfw: 0,
        views: 0,
        images : [],
        widths : [],
        heights : [],
        relationship: -1,
        meta: 0,
        supporters: [],
        react_comments: [],
        opening: false,
        action: "",
        action_lbl: "",
        reply_only: false,
        sponsored: false
    };
    // save first time
	return content;
};

export const CountNum = (num : number) : string => {
    if (num == null)
        return '';
    if (num > 1000000)
    {
        return Math.floor(num / 1000000) + "m";
    }
    if (num > 1000)
    {
        return Math.floor(num / 1000) + "k";
    }

    return num.toString();
};

export const FilterUniqueContent = (arr : any) : any => {
    let filterList : ContentInfo[] = [];
    if (arr == null)
        return filterList;

    for (var i = 0; i < arr.length; i++)
    {
        // filter the list
        var same = false;
        for (var j = 0; j < filterList.length; j++)
        {
            if (filterList[j].id == arr[i].id)
            {
                same = true;
                break;
            }
        }

        if (!same)
            filterList.push(arr[i]);
    }
    return filterList
}

export const ReponsiveContentResize = (div : string, arr : any) : any => {
    let contents : ContentInfo[] = [];
    if (arr == null)
        return contents;

    // retrieve the size div
    var mainDiv = document.getElementById(div);
    if (mainDiv == null)
        return arr;

    var scrWidth = mainDiv.offsetWidth;
    if (scrWidth <= 0)
        return arr;

    for (var i = 0; i < arr.length; i++)
    {
        let con : ContentInfo = arr[i];
        if (con.heights == null)
            continue;
        if (con.heights.length < 1)
            continue;

        DoItemResizeResponsive(scrWidth, con);
        
    }
    return arr;
}

export const ReponsiveContentItemResize = (div : string, con : ContentInfo) : ContentInfo => {
    // retrieve the size div
    var mainDiv = document.getElementById(div);
    if (mainDiv == null)
        return con;

    var scrWidth = mainDiv.offsetWidth;
    if (scrWidth <= 0)
        return con;

    if (con.heights == null)
        return con;
    if (con.heights.length < 1)
        return con;

    DoItemResizeResponsive(scrWidth, con);

    return con;
}

// resize a component width 
const DoItemResizeResponsive = (scrw : number, con : ContentInfo) => {
    for (var k = 0; k < con.heights.length; k++)
    {
        if (con.heights.length == 2)
            con.heights[k] = 200;
        else if (k == 0 && con.heights.length > 1)
            con.heights[k] = 250;
        else if (con.heights.length >= 4)
            con.heights[k] = 150;
        else if (con.heights.length >= 3)
            con.heights[k] = 150;
        else if (con.widths[k] > 0)
            con.heights[k] = (con.heights[k] * scrw) / con.widths[k];

        if (con.heights[k] > 800)
        {
            con.heights[k] = 800;
        }

        con.widths[k] = 0;
    }
}